import { render, staticRenderFns } from "./CompleteClinicProfile.vue?vue&type=template&id=f2a2de28&scoped=true&"
import script from "./CompleteClinicProfile.vue?vue&type=script&lang=js&"
export * from "./CompleteClinicProfile.vue?vue&type=script&lang=js&"
import style0 from "./CompleteClinicProfile.vue?vue&type=style&index=0&id=f2a2de28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a2de28",
  null
  
)

export default component.exports